module.exports = __webpack_public_path__ + "img/student-testimonial001.05069163.png";